<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    :storeModule="storeModule"
  />
</template>

<script>
import { DropDownSectionConsts } from 'client/util/Constants';
import { configurationCategoriesList } from 'client/util/Constants/ConfigurationCategoriesConstants';
import { extend } from 'lodash';
import { mapActions } from 'vuex';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';
import PolicyCategoriesFilter
  from 'components/ItemTable/CollectionFilterComponents/constants/PolicyCategoriesFilter';

const {
  selectOne,
} = DropDownSectionConsts;

export default {
  name: 'PolicyCategoryDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data() {
    return {
      dropDownMenuSections: [
        {
          menuLabel: 'category:',
          menuType: selectOne,
          menuItems: this.generateDropDownMenuItems(),
        },
      ],
    };
  },

  beforeCreate() {
    const { storeModule } = this.$options.propsData;

    extend(
      this.$options.methods,
      mapActions(storeModule, [
        'fetchCollection',
        'setFilter',
      ]),
    );
  },

  methods: {
    generateDropDownMenuItems() {
      return Object.values(configurationCategoriesList).map(category => ({
        filter: PolicyCategoriesFilter(category),
        label: category,
        action: () => this.handleDropDownAction(PolicyCategoriesFilter(category)),
      }));
    },
  },
};
</script>
